import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { ExportViewProps, ExportViewRef } from "./models";
import SearchFilter, { Filters } from "../../../Common/SearchFilter/SearchFilter";
import { searchFilterToExportExcelFilter } from "../../../Common/SearchFilter/utils";
import useDidMountEffect from "../../../Common/UseDidMountEffect";
import { ApiBackend } from "../../../../providers/apibackend";
import { Event } from "../../../../model/Event";

type SearchFilterType = {
    raceWeek?: string;
    discipline?: string;
    minAge?: number;
    okForCommercialFilter?: boolean;
    okForThirdPartyFilter?: boolean;
};

interface ISearchFilter {
    raceWeek?: string;
    discipline?: string;
    minAge?: number;
    okForCommercialFilter?: boolean;
    okForThirdPartyFilter?: boolean;
}

const EnteredForRaceWeek = forwardRef<ExportViewRef, ExportViewProps>((props, ref) => {
    const [searchFilter, setSearchFilter] = useState(null as ISearchFilter);
    const [events, setEvents] = useState(null as Event[]);
    useImperativeHandle(ref, () => ({
        isValid: () => {
            return !!searchFilter?.raceWeek && !!searchFilter?.discipline;
        }
    }));

    useEffect(() => {
        let backend = new ApiBackend();
        backend.listEvents().then((res) => {
            setEvents(res);
        });
    }, []);

    const disciplines = [{ name: "Skidor", value: "ski" }, { name: "Cykel", value: 'bike' }, { name: 'Löpning', value: 'run' }];

    useDidMountEffect(() => {
        props.onChange(searchFilterToExportExcelFilter<ISearchFilter>(searchFilter));
    }, [searchFilter]);

    const render = () => {
        return (
            <SearchFilter<SearchFilterType>
                id={"export-enteredforraceweek-filter"}
                filters={{
                    "raceWeek": {
                        id: "filter-raceWeek",
                        type: "GenericSelect",
                        label: "Evenemang",
                        size: 12,
                        multiple: false,
                        itemDefinition: {
                            items: events == null ? [] : events.map(x => { return { name: x.name, value: x.id } }),
                            itemValueType: "string"
                        }
                    },
                    "discipline": {
                        id: "filter-discipline",
                        type: "GenericSelect",
                        label: "Diciplin",
                        size: 12,
                        multiple: false,
                        itemDefinition: {
                            items: disciplines.map(x => { return { name: x.name, value: x.value } }),
                            itemValueType: "string"
                        }
                    },
                    "okForCommercialFilter": {
                        id: "filter-okForCommercialFilter",
                        type: "Checkbox",
                        label: "Applicera filter ok med reklam",
                        size: 12,
                        defaultValue: false,
                        multiple: false
                    },
                    "okForThirdPartyFilter": {
                        id: "filter-okForThirdPartyFilter",
                        type: "Checkbox",
                        label: "Applicera filter ok med 3:e part",
                        size: 12,
                        defaultValue: false,
                        multiple: false
                    },
                    "minAge": {
                        id: "filter-minAge",
                        type: "GenericSelect",
                        label: "Filter minsta ålder (valfritt)",
                        size: 12,
                        multiple: false,
                        itemDefinition: {
                            items: [16, 18].map(x => { return { name: x + '', value: x } }),
                            itemValueType: "number"
                        }
                    },
                }}
                persist={true}
                onInit={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
                onChange={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
            />
        );
    };

    return render();
});

export default EnteredForRaceWeek;
